import { render, staticRenderFns } from "./IssueDialog.vue?vue&type=template&id=c4d2cdc2&scoped=true&"
import script from "./IssueDialog.vue?vue&type=script&lang=js&"
export * from "./IssueDialog.vue?vue&type=script&lang=js&"
import style0 from "./IssueDialog.vue?vue&type=style&index=0&id=c4d2cdc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d2cdc2",
  null
  
)

export default component.exports